import { API_V2 } from "@Models/GWDomain";

// URLs base por microservicio (via gateway)
const LOCALS_BASE = `${API_V2}/locals`;
const RESERVAS_BASE = `${API_V2}/reservations`;
const CUSTOMERS_BASE = `${API_V2}/customers`;
const SERVICIOS_BASE = `${API_V2}/services`;

export const GET_LOUNGE_HOUR_API = `${LOCALS_BASE}/schedules`;

export const GET_APPOINTMENT_WEEK_API = `${RESERVAS_BASE}/week`;

export const GET_CLIENTS_API = `${CUSTOMERS_BASE}/search`;

export const GET_SERVICES_API = `${SERVICIOS_BASE}`;

export const GET_AVAILABLE_HOURS_API = `${RESERVAS_BASE}/available-hours`;

export const POST_CREATE_APPOINTMENT_API = `${RESERVAS_BASE}`;

export const PUT_EDIT_APPOINTMENT_API = `${RESERVAS_BASE}`;

export const DELETE_CANCEL_APPOINTMENT_API = `${RESERVAS_BASE}`;

export const GET_APPOINTMENT_STATES_API = `${RESERVAS_BASE}/states`;

export const GET_RESERVATION_HISTORY_API = (id: number | string) =>
  `${RESERVAS_BASE}/${id}/history`;
